import * as React from "react"
import classnames from "classnames"
import { Button as BSButton } from "reactstrap"

interface DownloadButton {
	link32: string
	link64: string
}

const x32 = "نسخه ۳۲ بیتی"
const x64 = "نسخه ۶۴ بیتی"
const pair = "نسخه ترکیبی"
const notAvaliable = "فایل موجود نیست"

interface Button {
	disabled?: boolean
	className?: string
	link?: string
}

const Button: React.FC<Button> = ({ link, className, ...props }) => {
	const Button = (
		<BSButton
			color="info"
			className={classnames("my-2", "py-1", className)}
			{...props}
		/>
	)
	return link ? (
		<a target="_blank" rel="noopener noreferrer" href={link}>
			{Button}
		</a>
	) : (
		Button
	)
}

const DownloadButton: React.FC<DownloadButton> = ({ link32, link64 }) => {
	if (link32 === link64 && link64 === ".")
		return (
			<Button className="text-nowrap" disabled>
				{notAvaliable}
			</Button>
		)

	if (link32 === link64)
		return (
			<Button className="text-nowrap" link={link32}>
				{pair}
			</Button>
		)

	return (
		<>
			<Button className="text-nowrap mb-2" link={link32}>
				{x32}
			</Button>
			<br />
			<Button className="text-nowrap" link={link64}>
				{x64}
			</Button>
		</>
	)
}

export default DownloadButton
